export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-annotate-8cefbaa9547094cacd0d4000a08a9441.svg";